// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeRequestHistoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ChangeRequestHistoryQuery = { __typename?: 'Query', changeRequest: { __typename?: 'ChangeRequest', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }> } };


export const ChangeRequestHistoryDocument = gql`
    query ChangeRequestHistory($id: ID!) {
  changeRequest(id: $id) {
    id
    history {
      ...HistoryFeedInfo
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}`;

/**
 * __useChangeRequestHistoryQuery__
 *
 * To run a query within a React component, call `useChangeRequestHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeRequestHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeRequestHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeRequestHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChangeRequestHistoryQuery, ChangeRequestHistoryQueryVariables> & ({ variables: ChangeRequestHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeRequestHistoryQuery, ChangeRequestHistoryQueryVariables>(ChangeRequestHistoryDocument, options);
      }
export function useChangeRequestHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeRequestHistoryQuery, ChangeRequestHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeRequestHistoryQuery, ChangeRequestHistoryQueryVariables>(ChangeRequestHistoryDocument, options);
        }
export function useChangeRequestHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeRequestHistoryQuery, ChangeRequestHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeRequestHistoryQuery, ChangeRequestHistoryQueryVariables>(ChangeRequestHistoryDocument, options);
        }
export type ChangeRequestHistoryQueryHookResult = ReturnType<typeof useChangeRequestHistoryQuery>;
export type ChangeRequestHistoryLazyQueryHookResult = ReturnType<typeof useChangeRequestHistoryLazyQuery>;
export type ChangeRequestHistorySuspenseQueryHookResult = ReturnType<typeof useChangeRequestHistorySuspenseQuery>;
export type ChangeRequestHistoryQueryResult = Apollo.QueryResult<ChangeRequestHistoryQuery, ChangeRequestHistoryQueryVariables>;